<template>
  <div class="generate__popup">
    <vs-popup id="print-invoice" class="text-center" title="Print Label" button-accept="false" button-cancel="false" :active.sync="isActive">
      <hr style="background: lightgrey" />
      <div class="vx-row mt-3">
        <div class="vx-col w-full">
          <div class="vx-col md:w-2/4 px-8">
            <div class="vx-row mb-2">
              <vs-input icon="icon icon-list" type="number" v-model.number="total_label" icon-pack="feather" class="w-full" label="Total Label" name="Total Label" v-validate="'required'" />
              <span class="text-danger text-center text-sm" v-show="errors.has('Total Label')">{{ errors.first('Total Label') }}</span>
            </div>
          </div>
          <div class="float-center">
            <vs-button class="mr-2 vs-con-loading__container" @click="printLabel = true" id="add-inventory-button" type="relief">Download Label</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <print-pdf v-if="printLabel" @close="printLabel = false" :totalBarcodes="total_label" :autoPrintPreview="true">
      <print-product-bar-code :product="product" :copies="total_label" />
    </print-pdf>
  </div>
</template>

<script>
import PrintPdf from '@/components/custom/PrintPdf.vue'
import PrintProductBarCode from '@/views/products/pdf/PrintProductBarCode.vue'

export default {
  name: 'GeneratePopup',
  components: {
    PrintPdf,
    PrintProductBarCode
  },
  props: {
    product: Object,
    isDownloadBarCodeModalShow: Boolean
  },

  data() {
    return {
      total_label: null,
      is_generate_label_popup_active: false,
      printLabel: false
    }
  },

  computed: {
    // close the poup
    isActive: {
      get() {
        return this.isDownloadBarCodeModalShow
      },
      set(val) {
        this.$emit('update:isDownloadBarCodeModalShow', val)
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.$emit('update:isDownloadBarCodeModalShow', false)
    next()
  }
}
</script>

<style></style>
